"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectModal = void 0;
var react_1 = __importStar(require("react"));
var Modal_1 = require("../Modal");
var styles = __importStar(require("./styles.module.css"));
var RejectModal = function (_a) {
    var active = _a.active, onClose = _a.onClose, onSave = _a.onSave;
    var _b = (0, react_1.useState)(""), reason = _b[0], setReason = _b[1];
    var _c = (0, react_1.useState)(false), error = _c[0], setError = _c[1];
    var handleOnClear = function () {
        setReason("");
    };
    var handleOnClose = function () {
        handleOnClear();
        onClose(false);
    };
    var handleOnSave = function () {
        if (reason.trim().length < 3) {
            setError(true);
        }
        else {
            setError(false);
            onSave(reason);
            handleOnClear();
        }
    };
    return (react_1.default.createElement(Modal_1.Modal, { className: styles.rejectModal, active: active, onClose: handleOnClose },
        react_1.default.createElement("div", { className: styles.signature },
            react_1.default.createElement("h2", null, "Please enter reason"),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", { className: styles.required, style: { display: error ? "block" : "none" } }, "The reason is mandatory"),
            react_1.default.createElement("textarea", { value: reason, onChange: function (e) { return setReason(e.target.value); } }),
            react_1.default.createElement("div", { className: styles.buttonContainer },
                react_1.default.createElement("div", { className: "".concat(styles.baseBtn, " ").concat(styles.cancelBtn), onClick: handleOnClear }, "CLEAR"),
                react_1.default.createElement("div", { className: styles.baseBtn, onClick: handleOnSave }, "SAVE")))));
};
exports.RejectModal = RejectModal;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1JlamVjdE1vZGFsL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFxQztBQUNyQyxrQ0FBOEI7QUFDOUIsMERBQTZDO0FBRXRDLElBQU0sV0FBVyxHQUFHLFVBQUMsRUFBeUI7UUFBeEIsTUFBTSxZQUFBLEVBQUUsT0FBTyxhQUFBLEVBQUUsTUFBTSxZQUFBO0lBQzFDLElBQUEsS0FBc0IsSUFBQSxnQkFBUSxFQUFDLEVBQUUsQ0FBQyxFQUFqQyxNQUFNLFFBQUEsRUFBRSxTQUFTLFFBQWdCLENBQUE7SUFDbEMsSUFBQSxLQUFvQixJQUFBLGdCQUFRLEVBQUMsS0FBSyxDQUFDLEVBQWxDLEtBQUssUUFBQSxFQUFFLFFBQVEsUUFBbUIsQ0FBQTtJQUV6QyxJQUFNLGFBQWEsR0FBRztRQUNsQixTQUFTLENBQUMsRUFBRSxDQUFDLENBQUE7SUFDakIsQ0FBQyxDQUFBO0lBQ0QsSUFBTSxhQUFhLEdBQUc7UUFDbEIsYUFBYSxFQUFFLENBQUE7UUFDZixPQUFPLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDbEIsQ0FBQyxDQUFBO0lBQ0QsSUFBTSxZQUFZLEdBQUc7UUFDakIsSUFBSSxNQUFNLENBQUMsSUFBSSxFQUFFLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRTtZQUMxQixRQUFRLENBQUMsSUFBSSxDQUFDLENBQUE7U0FDakI7YUFBTTtZQUNILFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQTtZQUNmLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQTtZQUNkLGFBQWEsRUFBRSxDQUFBO1NBQ2xCO0lBQ0wsQ0FBQyxDQUFBO0lBRUQsT0FBTyxDQUNILDhCQUFDLGFBQUssSUFBQyxTQUFTLEVBQUUsTUFBTSxDQUFDLFdBQVcsRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxhQUFhO1FBQ3hFLHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsU0FBUztZQUM1QixnRUFBNEI7WUFDNUIseUNBQU07WUFDTix1Q0FBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLFFBQVEsRUFBRSxLQUFLLEVBQUUsRUFBQyxPQUFPLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLE1BQU0sRUFBQyw4QkFFckU7WUFDTiw0Q0FBVSxLQUFLLEVBQUUsTUFBTSxFQUFFLFFBQVEsRUFBRSxVQUFDLENBQUMsSUFBSyxPQUFBLFNBQVMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxFQUF6QixDQUF5QixHQUFJO1lBQ3ZFLHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsZUFBZTtnQkFDbEMsdUNBQ0ksU0FBUyxFQUFFLFVBQUcsTUFBTSxDQUFDLE9BQU8sY0FBSSxNQUFNLENBQUMsU0FBUyxDQUFFLEVBQ2xELE9BQU8sRUFBRSxhQUFhLFlBRXBCO2dCQUNOLHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsT0FBTyxFQUFFLE9BQU8sRUFBRSxZQUFZLFdBRS9DLENBQ0osQ0FDSixDQUNGLENBQ1gsQ0FBQTtBQUNMLENBQUMsQ0FBQTtBQTNDWSxRQUFBLFdBQVcsZUEyQ3ZCIn0=